import { getSignInOriginCorrectionUrl, getWorkOsRedirectUri } from "./config";

/**
 * Start AuthKit PKCE only when the browser origin matches the redirect URI origin.
 * Otherwise navigate to the configured origin first so the code_verifier survives.
 */
export function beginWorkOsSignIn(signIn: () => void | Promise<void>): void {
  const correction = getSignInOriginCorrectionUrl(
    getWorkOsRedirectUri(),
    typeof window !== "undefined" ? window.location.href : undefined,
  );
  if (correction) {
    window.location.assign(correction);
    return;
  }
  void signIn();
}
